<template>
  <div class="spec-page">
    <AdBannerCarousel target-group="clients" :placement-id="1" />
    <section class="spec-hero">
      <div class="spec-hero__overlay"></div>
      <div class="spec-hero__content container">
        <h1>Wyszukiwarka specjalistów</h1>
        <p>Znajdź lekarza, behawiorystę lub placówkę w swojej okolicy.</p>
      </div>
    </section>

    <section class="spec-search section">
      <div class="container">
        <div class="spec-search__card">
          <h2>Wyszukaj specjalistę</h2>

          <form class="spec-search__form" @submit.prevent="searchSpecialists" @reset.prevent="resetSearch">
            <div class="field field--name">
              <input type="text" placeholder="imię / nazwa działalności" id="name" v-model="name">
            </div>

            <div class="field field--category">
              <select id="category" v-model="category">
                <option value="0">-- wybierz specjalizację --</option>
                <option :value="cat.id" :key="cat.id" v-for="cat in categories">{{ cat.name }}</option>
              </select>
            </div>

            <div class="field field--city">
              <input type="text" placeholder="miasto / miejscowość" id="city" autocomplete="address-level2" v-model="city">
            </div>

            <div class="field field--state">
              <select id="state" v-model="state">
                <option value="0">-- województwo --</option>
                <option :value="st.id" :key="st.id" v-for="st in states">{{ st.name }}</option>
              </select>
            </div>

            <div class="field field--submit">
              <button type="submit" class="btn btn--primary">Szukaj</button>
            </div>

            <div class="field field--reset">
              <button type="reset" class="btn btn--ghost">Resetuj</button>
            </div>
          </form>
        </div>
      </div>
    </section>

    <section class="section spec-results">
      <div class="container">
        <div class="section__head">
          <h2>Lista specjalistów</h2>
          <span v-if="itemsCount">Wyników: {{ itemsCount }}</span>
        </div>

        <div class="spec-pagination" v-if="showPages && itemsCount > 0">
          <button class="spec-pagination__arrow" @click="prevPage" :disabled="itemsPage <= 1">‹</button>
          <span>{{ itemsPage }}/{{ maxPages }}</span>
          <button class="spec-pagination__arrow" @click="nextPage" :disabled="itemsPage >= maxPages">›</button>
        </div>

        <div class="spec-grid" v-if="users.length > 0">
          <UserCard
              v-for="user in users"
              :key="user.id"
              :id="user.id"
              :name="user.role_id == 2 || user.role_id == 5 ? user.name : `${user.firstname} ${user.lastname}`"
              :category="user.category ? user.category.name : 'brak'"
              :city="user.address ? user.address : 'brak'"
              :role="user.role_id"
              :email="user.email"
              :image-url="user.image ? user.image.photo_url : null"
          />
        </div>

        <div v-else class="spec-empty">
          <h3 v-if="loadingSpecs">Ładowanie...</h3>
          <img v-if="loadingSpecs" src="@/assets/icons/loading.gif" alt="">
          <h3 v-if="!loadingSpecs">Brak wyników</h3>
        </div>

        <div class="spec-pagination" v-if="showPages && itemsCount > 0">
          <button class="spec-pagination__arrow" @click="prevPage" :disabled="itemsPage <= 1">‹</button>
          <span>{{ itemsPage }}/{{ maxPages }}</span>
          <button class="spec-pagination__arrow" @click="nextPage" :disabled="itemsPage >= maxPages">›</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import UserCard from '@/components/SpecialComponents/UserCard.vue'
import axios from 'axios'
import { useMeta } from 'vue-meta'
import AdBannerCarousel from "@/components/AdBanner.vue";

export default{
  name: 'SpecBrowserVue',
  setup() {
    useMeta({ title: 'Specjaliści' });
  },
  data() {
    return {
      name: '',
      category: '0',
      city: '',
      categories: [],
      itemsDisplayed: 30,
      itemsPage: 1,
      itemsCount: 0,
      users: [],
      showPages: true,
      loadingSpecs: false,
      state: '0',
      states: []
    };
  },
  computed: {
    maxPages() {
      return Math.max(1, Math.ceil(this.itemsCount / Number(this.itemsDisplayed)));
    }
  },
  mounted() {
    this.getCategories();
    this.getStates();
    this.searchSpecialists();
  },
  methods: {
    getStates() {
      axios.get('/State').then(res => {
        this.states = [];
        res.data.forEach((item) => {
          this.states.push({
            name: item.name,
            id: `${item.id}`
          });
        });
      });
    },
    getCategories() {
      axios.get('/Categories').then(res => {
        this.categories = res.data || [];
      }).catch(() => {});
    },
    searchSpecialists() {
      this.loadingSpecs = true;
      this.users = [];

      const payload = {
        page: this.itemsPage,
        limit: this.itemsDisplayed,
        sortAb: true
      };

      if (this.city) payload.city = this.city;
      if (this.name) payload.name = this.name;
      if (this.category !== '0') payload.category_id = this.category;
      if (this.state !== '0') payload.state_id = this.state;

      axios.post('/Users', payload).then(res => {
        const items = res?.data?.items || [];
        this.users = items.filter(item => item.role_id == 2 || item.role_id == 4 || item.role_id == 5 || item.role?.id == 2 || item.role?.id == 4 || item.role?.id == 5);
        this.itemsCount = res?.data?.count || 0;
      }).finally(() => {
        this.loadingSpecs = false;
      });
    },
    resetSearch() {
      this.name = '';
      this.category = '0';
      this.city = '';
      this.state = '0';
      this.itemsPage = 1;
      this.showPages = true;
      this.searchSpecialists();
    },
    prevPage() {
      if (this.itemsPage > 1) {
        this.itemsPage -= 1;
        this.searchSpecialists();
      }
    },
    nextPage() {
      if (this.itemsPage < this.maxPages) {
        this.itemsPage += 1;
        this.searchSpecialists();
      }
    }
  },
  components: {AdBannerCarousel, UserCard }
}
</script>

<style scoped lang='scss'>
.spec-page{
  background: #f9fafb;
  color: #1f2937;
  overflow-x: hidden;
  border-radius: 12px;
}
.container{
  width: min(1200px, calc(100% - 32px));
  margin: 0 auto;
}
.section{
  padding: 24px 0;
}
.section__head{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 12px;
  margin-bottom: 20px;
}
.spec-hero{
  position: relative;
  min-height: 260px;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  &__overlay{
    position: absolute;
    inset: 0;
    background: rgba(31, 41, 55, .65);
  }
  &__content{
    position: relative;
    z-index: 1;
    color: #fff;
    h1{
      margin: 0 0 8px;
      font-size: clamp(2.8rem, 5vw, 4.8rem);
    }
    p{
      margin: 0;
      color: #e5e7eb;
      font-size: 1.8rem;
    }
  }
}

.spec-search{
  padding-top: 20px;
  &__card{
    background: #fff;
    border-radius: 14px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 15px 40px rgba(0,0,0,.12);
    padding: 22px;
    h2{
      text-align: center;
      margin: 0 0 16px;
    }
  }

  &__form{
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    gap: 12px;
    align-items: stretch;

    .field{
      min-width: 0;
    }

    .field--name{ grid-column: span 3; }
    .field--category{ grid-column: span 3; }
    .field--city{ grid-column: span 2; }
    .field--state{ grid-column: span 2; }
    .field--submit{ grid-column: span 1; }
    .field--reset{ grid-column: span 1; }

    input, select{
      width: 100%;
      min-width: 0;
      border: 1px solid #d1d5db;
      border-radius: 8px;
      padding: 11px 12px;
      font-size: 1.5rem;
      background: #fff;
      box-sizing: border-box;
    }

    input:focus, select:focus{
      outline: none;
      border-color: #10b981;
      box-shadow: 0 0 0 1px #10b981;
    }
  }
}

.btn{
  border: none;
  border-radius: 8px;
  width: 100%;
  min-height: 44px;
  font-weight: 700;
  cursor: pointer;
  transition: .2s;
}
.btn--primary{
  background: #10b981;
  color: #fff;
}
.btn--primary:hover{ background: #059669; }
.btn--ghost{
  background: #f3f4f6;
  color: #374151;
}
.btn--ghost:hover{ background: #e5e7eb; }

.spec-pagination{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin: 16px 0 22px;
  &__arrow{
    width: 34px;
    height: 34px;
    border: none;
    border-radius: 8px;
    background: #10b981;
    color: #fff;
    cursor: pointer;
    font-size: 2rem;
    line-height: 1;
  }
  &__arrow:disabled{
    opacity: .4;
    cursor: not-allowed;
  }
}

.spec-grid{
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}
.spec-empty{
  display: flex;
  flex-direction: column;
  align-items: center;
  img{ width: 42px; }
}
@media (max-width: 1100px){
  .spec-search__form{
    grid-template-columns: repeat(6, minmax(0, 1fr));

    .field--name{ grid-column: span 3; }
    .field--category{ grid-column: span 3; }
    .field--city{ grid-column: span 3; }
    .field--state{ grid-column: span 3; }
    .field--submit{ grid-column: span 3; }
    .field--reset{ grid-column: span 3; }
  }
}
@media (max-width: 900px){
  .spec-grid{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 640px){
  .spec-search__form{
    grid-template-columns: 1fr;

    .field--name,
    .field--category,
    .field--city,
    .field--state,
    .field--submit,
    .field--reset{
      grid-column: auto;
    }
  }

  .spec-grid{
    grid-template-columns: 1fr;
  }

  .section__head{
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>